/*

Adityaaa 09/23/2022 2701350359 Implemented Draggable Dialog box
Sohel 10/29/2022 2701350359 Added Created For and Created By Fields
Prakash  26/10/2022 2701350359 Added classes for Text-Fields and Buttons.
Prakash 10/29/2022 2701350359 Added UX changes for Fields.
Prakash 10/30/2022 2701350359 Renamed  class Styling for Variant-Standard.
Prakash 10/31/2022 2701350359 Renamed  Aligned fields.
akhila 11/02/2022 2701350359 adding title and draft fields in search.
Prakash Gummala 11/02/2022 2701350359 Fixed Responsiveness for 768px.
akhila 11/07/2022 2701350359 changed  button clear to reset
Sai Krishna 11/08/2022 3031450488 Run popup size increased
Prakash Gummala 11/10/2022  3031450488 Fixed TextFields Alignments.
Sai Krishna 11/01/2022 3031450488 After run table refresh bug fixed
Rajesh 11/15/2022 2701350359 passing props to report table.
Rajesh 11/16/2022 2701350359 changed passing props to report table.
Prakash 11/18/2022 2701350359  Added space for DialogBox.
Rajesh 11/18/2022 2701350359 UI changes.
Akhila 11/25/2022 2701350359 Bug fixed search functionality
Raghu 11/28/2022  2701350359 Responsive Button Alignment Fixes
Akhila 11/25/2022 2701350359 Bug fixed search functionality
Rajesh 11/28/2022 2701350359 fixed  status dropdown values display in night jobs .
Gummala Prakash 11/28/2022 2701350359 Fixed Button Alignment.
Saikrishna  11/29/2022  2701350359 Validations and requirement changes done in reports basic info.
Gummala Prakash 11/29/2022 2701350359 Fixed Fields Alignments and Responsiveness.
Rajesh 12/01/2022 2701350359 disabled status for night jobs
Sai maheshwar 12/01/2022 2701350359 fixed runreport download issue.
Sai Maheshwar 12/05/2022 3031450488 added map fields save and close
Sohel 12/05/2022 2701350359 created For changed textField to dropdown
lalitha 12/07/2022 2701350359 added Created By field
lalitha 12/07/2022 2701350359 fixed page break issue in created by field and created for field
akhila 12/08/2022  2701350359 adding session storage for search items
kavya9reddy 12/09/2022 2701350359 Added createdDate field
Akhila 12/13/2022 2701350359 bugFix session stoarge
Suresh Peddavoora 12/16/2022 2701350359 Fixed TextFields alignments in responsive
Prakash 12/21/2022 2700753823 Fields and Buttons Responsiveness.
kavyareddy 01/04/2023 2700753823 Fixed reportcode issue
Akhila 02/03/2023 2700753823 added last run date field
kavyareddy 02/07/2023 2700753823 Changes in createdBy dropdown
Rohini 02/09/2023 2698964415 Added the new classname and text fields enhancements
Dilip 02/09/2023 2700753823 added created for dropdown
Prakash 02/14/2023 2700753823 Implemented New UI Changes for dropdown Component.
Ravi 02/15/2023 2700753823 Fixed Client Code reset Issue
Prakash 02/16/2023 2700753823 Fixed UI-Bug.
//suresh peddavoora 02/27/2023 2700753823 New UI changes
Raghu 02/27/2023 2700753823 button alignments
suresh peddavoora 02/28/2023 2700753823 New UI changes fixed
Raghu 03/06/2023 2700753823 added new classname for datepicker
T Santosh Kumar 17/03/2023 2700753823 New UI Alignment Changes
Prakash 03/17/2023 2700753823 fixed alignments in Responsive and desktop.
Akhila 04/19/2023 2700753823 modified clientCode dropDownData
Akhila 06/08/2023 2700753823 created date change to date created field and column
AKhila 06/08/2023 2700753823 re arrange the search screen with table column
Uday  13/10/2023 2700753823 fixed button alignment issues

*/

import React, {useEffect, useState, useContext, useRef} from 'react';
import {Formik} from 'formik';
import {Button, TextField, FormHelperText} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../util/ErrorBoundaryForComponents';
import {useDispatch, useSelector} from 'react-redux';
import PageLoader from '../../../../components/PageLoader';
import RuleGroupSearchTable from './ReportMasterSearchTable';
import DialogBox from '../../../../components/DialogBox/DraggableDialogBox';
import RunaReportMaster from './RunaReport';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../components/CustomSnackBar';
import {
  ResetMessage as resetMessage,
  ResetRunReportToggle as resetRunReportToggle,
  ResetStatus as resetStatus,
} from '../../../../redux/reducers/BRE/AddReportMaster';
import {
  fetchCreatedByDropDownData,
  fetchCreatedForDropDownData,
} from '../../../../redux/reducers/ReportMaster';
import * as Yup from 'yup';
import {getAllReportCreatedForData} from '../../../../redux/reducers/ReportMaster';
import DateFnsUtils from '@date-io/date-fns';
import {MuiPickersUtilsProvider, KeyboardDatePicker} from '@material-ui/pickers';
import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../components/FormComponents/GuiTextField';
import {getClientCodeDropDownData} from '../../../../redux/reducers/TriggerGroup';
import {createForOptions, createdByOptions} from '../../../../util/CreatedByForOptions';

const ReportMasterSearch = ({
  setTabValue,
  setSelectedRows,
  selectedRows,
  setBreCode,
  setReportCode,
  openTemplate,
  setOpenTemplate,
  copy,
  setCopy,
  reportMasterSearch,
  setReportSearchCode,
  setReportSearch,
  setReportData,
  setEditExisting,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const [reportDialogData, setReportDialogData] = useState();
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);
  const {isLoading} = useSelector(({addRuleGroup}) => addRuleGroup);
  const {errorMsg, successMsg, addReportMasterStatus, runReportToggle} = useSelector(
    ({addReportMaster}) => addReportMaster,
  );
  const {createdByData, createdForData} = useSelector(
    ({reportMaster}) => reportMaster,
  );
  const schema = Yup.object().shape({
    // code: Yup.string().matches(regexp, "White space and special character are not allowed"),
    createdDate: Yup.date().typeError('Invalid date format').nullable(),
    lastRunDate: Yup.date().typeError('Invalid date format').nullable(),
  });

  const formikRef = useRef();

  const StatusOptions = [
    {key: 'Y', value: 'Draft'},
    {key: 'N', value: 'Completed'},
  ];
  const SearchSessionReport = JSON.parse(sessionStorage.getItem('Report'));
  const initialValues = {
    category: '',
    displayName: '',
    globalField: '',
    description: '',
    tableName: '',
    tableField: '',
    fieldType: '',
    code: '',
    title: '',
    createdBy: '',
    createdFor: '',
    createdDate: null,
    lastRunDate: null,
    clientCode: '',
    isDraft: reportMasterSearch ? {key: 'N', value: 'Completed'} : '',
  };
  const handleSubmit = (data) => {
    setSearchFlag(true);
    setSearchData(data);
    setSubmit(true);
    if (!reportMasterSearch) {
      sessionStorage.setItem('Report', JSON.stringify(data));
    }
  };
  const handleClose = () => {
    setOpen(false);
    setOpenTemplate(false);
  };
  const [searchFlag, setSearchFlag] = useState(false);
  useEffect(() => {
    dispatch(getClientCodeDropDownData());
  }, []);
  useEffect(() => {
    dispatch(fetchCreatedByDropDownData('report'));
    dispatch(fetchCreatedForDropDownData('report'));
  }, [dispatch]);

  useEffect(() => {
    if (runReportToggle) {
      handleClose();
      // setSearchData({});
      // setSubmit(true);
      // formikRef?.current?.resetForm();
      setTimeout(() => {
        dispatch(resetMessage());
        dispatch(resetStatus());
        dispatch(resetRunReportToggle());
      }, 3000);
    } else {
      if (addReportMasterStatus === 200) {
        handleClose();
        setSearchData({});
        setSubmit(true);
        formikRef?.current?.resetForm();
        setTimeout(() => {
          dispatch(resetMessage());
          dispatch(resetStatus());
        }, 3000);
      }
    }
  }, [addReportMasterStatus, runReportToggle]);
  useEffect(() => {
    dispatch(getAllReportCreatedForData());
  }, []);
  return (
    <div className={reportMasterSearch ? 'col-12' : ''}>
      <h2 className="search-title">Report Search</h2>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={
          SearchSessionReport && !reportMasterSearch ? SearchSessionReport : initialValues
        }
        validationSchema={schema}
        enableReinitialize
        innerRef={formikRef}
      >
        {(props) => {
          const {
            values,
            handleChange,
            handleSubmit,
            handleReset,
            handleBlur,
            errors,
            touched,
            setFieldValue,
          } = props;

          return (
            <div className="">
              <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                <div className="standard-field-textfields new-standard-textfields">
                  <ErrorBoundaryForComponents>
                    <div className="form-row">
                      <div className="col-xs-4 col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                        <TextField
                          className={` ${classes.labelName}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Report Name`}
                          label="Report Name"
                          name="code"
                          value={values?.code}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.code}
                          error={Boolean(touched.code && errors.code)}
                        />
                        <FormHelperText>
                          {touched.code && errors.code && errors.code}
                        </FormHelperText>
                      </div>
                      {/* <div className="col-xs-4 col-sm-6 col-md-3 col-lg-2 form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="standard"
                          placeholder={`Enter Report Title`}
                          label="Report Title"
                          name="title"
                          value={values?.title}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </div> */}
                      <div className="col-xs-4 col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                        <TextField
                          className={` ${classes.labelName}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Report Description`}
                          label="Report Description"
                          name="description"
                          value={values.description}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="createdFor"
                          id="createdFor"
                          size="small"
                          value={values.createdFor}
                          options={createdForData}
                          getOptionLabel={(option) => {
                            return option && option?.userLoginName ? option?.userLoginName : '';
                          }}
                          renderOption={(option) => {
                            return createForOptions(option);
                          }}
                          onChange={(e, value) => {
                            setFieldValue('createdFor', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={` ${classes.labelName}`}
                                {...params}
                                variant="outlined"
                                margin="dense"
                                label="Report Owner"
                                placeholder="Select Report Owner"
                              />
                              <FormHelperText variant="outlined">
                                {touched.createdFor && errors.createdFor}
                              </FormHelperText>
                            </div>
                          )}
                        />
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="createdBy"
                          id="createdBy"
                          size="small"
                          value={values.createdBy}
                          options={createdByData || []}
                          getOptionLabel={(option) => {
                            return option && option?.userLoginName ? option?.userLoginName : '';
                          }}
                          renderOption={(option) => {
                            return createdByOptions(option);
                          }}
                          onChange={(e, value) => {
                            setFieldValue('createdBy', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={` ${classes.labelName}`}
                                {...params}
                                variant="outlined"
                                margin="dense"
                                label="Created By"
                                placeholder="Select Created By"
                              />
                            </div>
                          )}
                        />
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            className={` ${classes.labelName} account-date-picker`}
                            format="MM/dd/yyyy"
                            placeholder="MM/DD/YYYY"
                            fullWidth
                            value={values.createdDate}
                            name="createdDate"
                            onBlur={handleBlur}
                            inputVariant="outlined"
                            helperText=""
                            label="Date Created"
                            onChange={(val) => {
                              setFieldValue('createdDate', val);
                            }}
                            autoOk
                            margin="dense"
                            touched={touched?.createdDate}
                            error={Boolean(touched?.createdDate && errors?.createdDate)}
                          />
                        </MuiPickersUtilsProvider>
                        <FormHelperText variant="outlined">
                          {touched.createdDate && errors.createdDate ? errors.createdDate : ''}
                        </FormHelperText>
                      </div>

                      <div className="col-xs-4 col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                        <GuiAutoComplete
                          classes={`${
                            !reportMasterSearch ?
                              {
                                popper: classes.popper,
                                option: classes.option,
                              } :
                              ''
                          }`}
                          name="isDraft"
                          disabled={reportMasterSearch}
                          id="isDraft"
                          size="small"
                          options={StatusOptions}
                          required
                          value={values.isDraft}
                          getOptionLabel={(option) => {
                            return option && option?.value;
                          }}
                          onChange={(e, value) => {
                            handleChange(e);
                            setFieldValue('isDraft', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                {...params}
                                className={` ${classes.labelName}`}
                                variant="outlined"
                                margin="dense"
                                // InputLabelProps={{ shrink: true }}
                                label="Status"
                                placeholder="Select Status"
                              />
                            </div>
                          )}
                        />
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            className={` ${classes.labelName} account-date-picker`}
                            format="MM/dd/yyyy"
                            placeholder="MM/DD/YYYY"
                            fullWidth
                            value={values.lastRunDate}
                            name="lastRunDate"
                            onBlur={handleBlur}
                            inputVariant="outlined"
                            helperText=""
                            label="Last Run Date"
                            onChange={(val) => {
                              setFieldValue('lastRunDate', val);
                            }}
                            autoOk
                            margin="dense"
                          />
                        </MuiPickersUtilsProvider>
                        <FormHelperText variant="outlined">
                          {touched.lastRunDate && errors.lastRunDate ? errors.lastRunDate : ''}
                        </FormHelperText>
                      </div>
                      <div className="col-xl-3 col-lg-3 col-md-4 mb-3">
                        <div className="d-flex align-items-center justify-content-md-center justify-content-lg-start">
                          <Button
                            variant="outlined"
                            className={`mr-1 reset-btn ${classes.buttonRoot}`}
                            onClick={() => {
                              handleReset();
                              setSearchData(initialValues);
                              setSubmit(true);
                              sessionStorage.removeItem('Report');
                            }}
                          >
                            Reset
                          </Button>
                          <Button
                            variant="outlined"
                            type="submit"
                            className={`search-btn ml-1 ${classes.buttonRoot}`}
                          >
                            Search
                          </Button>
                        </div>
                      </div>
                    </div>
                  </ErrorBoundaryForComponents>
                </div>
              </form>
              {isLoading && <PageLoader />}
              {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
              {successMsg && <SuccessSnackbar successMsg={successMsg} />}
            </div>
          );
        }}
      </Formik>
      <RuleGroupSearchTable
        setTabValue={setTabValue}
        searchData={searchData}
        setSelectedRows={setSelectedRows}
        selectedRows={selectedRows}
        searchFlag={searchFlag}
        setBreCode={setBreCode}
        setOpen={setOpen}
        copy={copy}
        setReportDialogData={setReportDialogData}
        setSubmit={setSubmit}
        submit={submit}
        setSearchData={setSearchData}
        setCopy={setCopy}
        reportMasterSearch={reportMasterSearch}
        setReportSearchCode={setReportSearchCode}
        setReportSearch={setReportSearch}
        setReportData={setReportData}
        setEditExisting={setEditExisting}
      />
      <DialogBox open={open} dialogClose={handleClose} title="Run a Report" maxWidth="xl">
        <RunaReportMaster reportDialogData={reportDialogData} setSubmit={setSubmit} />
      </DialogBox>
    </div>
  );
};

export default ReportMasterSearch;
